import { useCurrentUser } from './useCurrentUser'

export function useProjectAccess(projectId?: number) {
  const { grants, isSuperAdmin, loading } = useCurrentUser()
  const grant = projectId ? grants.find(g => g.clientId === projectId) : undefined
  return {
    loading,
    role: grant?.role ?? null,
    modules: grant?.modules ?? [],
    hasModule: (module: string) => isSuperAdmin || (grant?.modules.includes(module) ?? false),
    hasRole: (min: 'viewer' | 'editor' | 'owner') => {
      if (isSuperAdmin) return true
      const rank: Record<string, number> = { viewer: 1, editor: 2, owner: 3 }
      return grant ? rank[grant.role] >= rank[min] : false
    },
    isSuperAdmin,
  }
}
